import React, {Component} from 'react';
import {Col, ControlLabel, FormControl, FormGroup, Row} from 'react-bootstrap';
import moment from 'moment'
import {format} from "../../utils/date";

export const parseBirthDate = (v, allowYearOnly) => {
	if (!v) {
		return null
	}
	if (allowYearOnly && ("" + v).length === 4) {
		return 1 * v;
	}
	return new Date(v)
};

class BirthDateField extends Component {

	constructor(props) {
		super(props);

		const {input} = this.props;
		const value = input.value || (input.value === "" ? null : input.value);

		if (value && this.props.allowYearOnly && ("" + value).length === 4) {
			this.state = {
				year: value,
				month: "",
				day: ""
			};

		} else {
			const d = moment(value);

			this.state = {
				year: d.isValid() ? d.year() : (this.props.allowYearOnly && value ? value : ""),
				month: d.isValid() ? d.month() + 1 : "",
				day: d.isValid() ? d.date() : ""
			};
		}

		this.handleDayChange = this.handleDayChange.bind(this);
		this.handleMonthChange = this.handleMonthChange.bind(this);
		this.handleYearChange = this.handleYearChange.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
	}

	handleDayChange(e) {
		const target = e.target || e;
		this.setState({day: target.value}, this.onValueChange);
	}

	handleMonthChange(e) {
		const target = e.target || e;
		this.setState({month: target.value}, this.onValueChange);
	}

	handleYearChange(e) {
		const target = e.target || e;
		this.setState({year: target.value}, this.onValueChange);
	}

	onValueChange() {
		const {day, month, year} = this.state;
		const {onChangeHook, input} = this.props;
		let value = null;
		if (day !== "" && day > 0 && month !== "" && month > 0 && year !== "" && year > 1000 && year < 3000) {
			const parsed = moment.utc({day, month: month - 1, year});
			if (!isNaN(parsed)) {
				value = format(parsed, "YYYY-MM-DD")
			}
		} else if (this.props.allowYearOnly && year !== "" && year > 1000 && year < 3000) {
			value = +year;
		}

		if (onChangeHook) {
			onChangeHook(value)
		}
		input.onChange(value);
	}

	render() {

		const {
			feedbackIcon,
			input,
			label,
			sizes,
			disabled,
			meta: {error, warning, touched}
		} = this.props;

		let message;
		const validationState = touched ? (error && "error") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>;
		}

		return (
			<FormGroup controlId={input.name} validationState={validationState}>
				<Col sm={sizes && sizes[0] ? sizes[0] : 4} componentClass={ControlLabel}>{label}</Col>
				<Col sm={sizes && sizes[1] ? sizes[1] : 8}>
					<Row className={"split-date-picker"}>
						<Col xs={3} className={"split-date-picker-day"}>
							<input
								className="form-control"
								name={input.name + "_day"}
								value={this.state.day}
								onChange={this.handleDayChange}
								type={"text"}
								maxLength={2}
								disabled={disabled}
								placeholder={'DD'}
								pattern={'[0-3]?[0-9]'}
							/>
						</Col>
						<Col xs={3} className={"split-date-picker-month"}>
							<input
								className="form-control"
								maxLength={2}
								name={input.name + "_month"}
								value={this.state.month}
								onChange={this.handleMonthChange}
								type={"text"}
								disabled={disabled}
								placeholder={'MM'}
								pattern={'[01]?[0-9]'}
							/>
						</Col>
						<Col xs={6} className={"split-date-picker-year"}>
							<input
								className="form-control"
								maxLength={4}
								name={input.name + "_year"}
								value={this.state.year}
								onChange={this.handleYearChange}
								type={"text"}
								disabled={disabled}
								placeholder={'RRRR'}
								pattern={'(19|20)[0-9]{2}'}
							/>
						</Col>
					</Row>
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}

export default BirthDateField



// WEBPACK FOOTER //
// ./src/components/form/BirthDateField.js